import squeezing from '../../../../assets/svgs/actors/amyStephanie/squeezing'

import { SQUEEZING } from '../../../../constants/scene/actors/amyStephanie'

export default {
    [SQUEEZING]: squeezing,
}
